import style from './index.module.scss';

function CategoryList({ categoryList, categoriesAlias }) {
    if (categoriesAlias === '') {
        categoriesAlias = 'category';
    }
    return (
        <div className={style.categories}>
            {categoryList &&
                Object.values(categoryList)
                    .sort((a, b) => parseInt(a.order) - parseInt(b.order))
                    .map((category) => {
                        return (
                            <a
                                href={`/${categoriesAlias}/${category.slug}`}
                                key={category.term_id}
                                dangerouslySetInnerHTML={{ __html: category.name }}
                                className={
                                    window.location.pathname.split('/').slice(-2).shift() === category.slug
                                        ? style.active
                                        : undefined
                                }
                            />
                        );
                    })}
        </div>
    );
}

export default CategoryList;
